import $ from 'jquery'

var status = 1
var lastItem = false

async function init () {

  $('.factoringtest-slider-wrapper').each(async function () {
    await import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick')
    $(this).on('init', function (event, slick) {
      $(this).siblings('.count-box').html((slick.currentSlide + 1) + '/' + (slick.slideCount - 1))
    })

    $(this).on('afterChange', function (event, slick, currentSlide) {
      if (!lastItem) {
        $(this).siblings('.count-box').html((slick.currentSlide + 1) + '/' + (slick.slideCount - 1))
      }

      if ((slick.$slides.length - 1) == currentSlide + slick.options.slidesToScroll) {
        lastItem = true
      }
    })

    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      cssEase: 'linear',
      draggable: false,
      swipe: false,
    })
    clickNext($(this))
  })
}

function clickNext (el) {
  var buttons = el.parent().find('[data-question-slider]')

  buttons.each(function () {
    $(this).on('click', function (event) {
      event.preventDefault()
      el.slick('slickNext')

      if ($(this).attr('data-question-slider') == 0) {
        status = 0
      }

      if (lastItem) {
        el.siblings('.count-box').html('&nbsp;')
        el.siblings('.count-box').css('display', 'none')
        el.find('#item_' + status).css('display', 'block')
        el.find('.question-box p').css('visibility', 'hidden')
        el.parent().find('.answer_' + status).css('display', 'flex')
        el.parent().find('.question-buttons').toggle('slow')
        el.parent().find('.answer-buttons').toggle('slow')
        el.parent().removeClass('question-mark').addClass('hook')
      }
    })
  })
}

export default {
  init
}
